import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import MonthlySummaryCards from "../../BalanceSheet/components/MonthlySummaryCards";
import BreakdownTable from "../../BalanceSheet/components/BreakdownTable";
import { BreakdownRow } from "../../BalanceSheet/types";
import { COLOR } from "../../BalanceSheet/utils/format";
import { BriefSection } from "../types";

interface Props {
  section: BriefSection;
  onRowClick: (section: BriefSection, row: BreakdownRow) => void;
}

/**
 * One month (or month slice) of the brief report: heading, the 4 summary
 * cards with the equation, and Detailed Income / Detailed Expenses side by
 * side. Used once for Monthly, three times for 3 Months, N times for Custom.
 */
const MonthlyBriefSection: React.FC<Props> = ({ section, onRowClick }) => (
  <Box component="section" aria-label={section.label} sx={{ mb: 5 }}>
    <Box sx={{ display: "flex", alignItems: "baseline", gap: 1.5, mb: 1.5, pb: 1, borderBottom: "2px solid #e0e0e0" }}>
      <Typography variant="h6" fontWeight={700}>
        {section.label}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {section.startDate} to {section.endDate}
      </Typography>
    </Box>

    <MonthlySummaryCards report={section} />

    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <BreakdownTable
          title="Detailed Income"
          columnLabel="Income Source"
          sections={[
            { rows: section.incomeBreakdown },
            { title: "Partner Deposits", rows: section.depositBreakdown },
          ]}
          totalLabel="Total Income"
          total={section.incomeTotal}
          headerBg={COLOR.greenBg}
          totalColor={COLOR.greenDark}
          emptyLabel="No income in this period."
          onRowClick={(row) => onRowClick(section, row)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <BreakdownTable
          title="Detailed Expenses"
          columnLabel="Expense Category"
          sections={[{ rows: section.expenseBreakdown }]}
          totalLabel="Total Expenses"
          total={section.expenseTotal}
          headerBg={COLOR.redBg}
          totalColor={COLOR.redDark}
          emptyLabel="No expenses in this period."
          onRowClick={(row) => onRowClick(section, row)}
        />
      </Grid>
    </Grid>
  </Box>
);

export default MonthlyBriefSection;
